import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useCompareValuesPerYearPerMonth } from './hooks/useCompareValuesPerYearPerMonth';

export const CompareValuesPerYearPerMonth = () => {
    const { series, subtitles } = useCompareValuesPerYearPerMonth();

    return (
        <SimpleBars
            title={`Evolução do Total da Quantidade Aprovada do Procedimento e a Quantidade Produzida (Apresentada)`}
            series={series}
            subtitles={subtitles}
            height={320}
            showDataLabels={false}
        />
    );
};
